import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Terms from "../../modals/terms";
import "./Modaldata.css";

const CenteredModal = ({ show, handleClose, terms }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="p-3"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>Terms And Conditions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div dangerouslySetInnerHTML={{ __html: terms }} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const Modaldata = () => {
  const navigate = useNavigate();
  const { type, apiService } = useParams();
  const terms = new Terms().getTerms();
  const location = useLocation();
  const { payLoad } = location.state || {};
  const [selectedOption, setSelectedOption] = useState(null);

  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);


  const handleButtonClick = (item) => {
    setSelectedOption(item);
  };

  // Function to check balance via API
  const checkBalance = async (msisdn) => {
    const requestBody = {
      msisdn: msisdn,
    };
    try {
      const response = await fetch(
        "https://Digital.webdoc.com.pk/Promotion/public/api/v1/service/check-balance",
        {
          method: "POST",
          body: JSON.stringify(requestBody),
        }
      );
      const data = await response.json();
      if (data.statusCode === "0000") {
        // Balance check successful
        const balance = parseFloat(data.payLoad.bal);
        if (balance < selectedOption.insurance_amount) {
          // Show low balance notification
          Swal.fire({
            title: "Low Balance",
            text: `You do not have enough balance to subscribe to this service. Your balance is Rs. ${balance}.`,
            icon: "warning",
            confirmButtonText: "OK",
          });
          return false;
        }
        return true; // Balance is sufficient
      } else {
        // Balance check failed
        Swal.fire({
          title: "Error",
          text: "Unable to check balance. Please try again later.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return false;
      }
    } catch (error) {
      console.error("Error checking balance:", error);
      Swal.fire({
        title: "Error",
        text: "An error occurred while checking the balance. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return false;
    }
  };

  const handlePayNowClick = async () => {
    if (selectedOption) {
      const msisdn = JSON.parse(sessionStorage.getItem("msisdn"));

      // Step 1: Check balance before proceeding with subscription
      const isBalanceSufficient = await checkBalance(msisdn);
      if (!isBalanceSufficient) {
        return; // Don't proceed if balance is insufficient
      }

      const { id, insurance_amount } = selectedOption;
      const requestBody = {
        api_service: apiService,
        serviceid: id,
        msisdn: msisdn,
      };

      try {
        const response = await fetch(
          "https://Digital.webdoc.com.pk/Promotion/public/api/v1/service/subscribe",
          {
            method: "POST",
            body: JSON.stringify(requestBody),
          }
        );
        const data = await response.json();

        if (data.statusCode === 100) {
          if (data.statusMessage === "already an active subscriber") {
            await Swal.fire({
              title: "Already Subscribed",
              text: "You are already an active subscriber to this service.",
              icon: "info",
              confirmButtonText: "OK",
            });
          } else {
            await Swal.fire({
              title: "Success!",
              text: "Successfully subscribed to the service.",
              icon: "success",
              confirmButtonText: "OK",
            });

            // Pass the subscription data to the next page
            navigate(`/subscribed-package-details/${apiService}`, {
              state: { subscription: selectedOption }, // passing the selected subscription
            });
          }
        } else {
          await Swal.fire({
            title: "Subscription Failed",
            text: "Subscription failed. Please try again.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      } catch (error) {
        console.error("Error subscribing to service:", error);
        await Swal.fire({
          title: "Error",
          text: "An error occurred while subscribing. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } else {
      await Swal.fire({
        title: "No Option Selected",
        text: "Please select an option before proceeding.",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
  };

 useEffect(() => {
    if (payLoad && payLoad.result.length > 0) {
      setSelectedOption(payLoad.result[0]); // Set the first option as default
    }
  }, [payLoad]);

  if (!payLoad) {
    return;
  }

  return (
    <>
      <div className="row m-3 mt-2 position-relative">
        <div className="col-12 text-center">
          <p className="custome-textfont">
            Select price point to subscribe to the service
          </p>
        </div>
        <div className="col-12">
          <div className="row d-flex justify-content-center">
            {payLoad.result.map((item) => (
              <div key={item.id} className="col-4 text-center mb-1 p-2">
                <Button
                  style={{
                    background:
                      selectedOption?.id === item.id
                        ? "#8cc63e"
                        : "transparent",
                    border:
                      selectedOption?.id === item.id
                        ? "none"
                        : "1px solid #dee2e6",
                    color: selectedOption?.id === item.id ? "white" : "black",
                  }}
                  className="w-100 p-2 mt-2"
                  onClick={() => handleButtonClick(item)}
                >
                  Rs. {item.insurance_amount} <br />/{" "}
                  {item.charge_interval === "1"
                    ? "Daily +tax"
                    : item.charge_interval === "7"
                    ? "Weekly +tax"
                    : item.charge_interval === "30"
                    ? "Monthly +tax"
                    : item.charge_interval === "365"
                    ? "Yearly +tax"
                    : `${item.charge_interval} days`}
                </Button>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="d-flex flex-column">
            <p className="dark-border rounded-border bg-secondary p-3 fs-15 text-white">
              Coverage:
              <strong
                className="float-end"
                style={{ fontSize: "15px", color: "white" }}
              >
                {selectedOption ? `Rs. ${selectedOption.amount}` : "-"}
              </strong>
            </p>
          </div>
        </div>
      </div>
      {selectedOption && selectedOption.features && (
        <div className="row m-1">
          <div className="col-12">
            <div className="d-flex flex-column">
              <div
                className="feature-list"
                dangerouslySetInnerHTML={{
                  __html: selectedOption.features,
                }}
              />
            </div>
          </div>
        </div>
      )}

      <div className="fixed-bottom-center p-2">
        <div className="container">
          <div className="row">
            <div className="col-12 d-flex justify-content-center align-items-center">
              <small>
                <a href="javascript:void(0);" className="ms-1"></a>
              </small>
            </div>
            <button
              className="paynow-button btn w-100"
              onClick={handlePayNowClick}
            >
              Subscribe
            </button>
          </div>
        </div>
      </div>

      <CenteredModal show={show} handleClose={handleClose} terms={terms} />
    </>
  );
};

export default Modaldata;
